import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react'
import type { FormEvent } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import { LinkButton } from '@/shared/ui/Button/LinkButton'
import { PrimaryButton } from '@/shared/ui/Button/PrimaryButton'
import { SecondaryButton } from '@/shared/ui/Button/SecondaryButton'
import { CancelModal } from '@/shared/ui/Modals/CancelModal/index'
import { ModalRoot, ModalTrigger } from '@/shared/ui/Modals/styles'

export type FooterActionsProps = {
  cancelModalOpen?: boolean
  onCancelModalOpen?: (open: boolean) => void
  onHandleGoBack?: (event: FormEvent) => void
  canGoBack?: boolean
  primaryButtonDisabled: boolean
  primaryButtonText?: string
  loading: boolean
  onCancelConfirm: () => void
  onCancelDismiss?: () => void
  onCancelRequest?: () => void
  trackEvents?: {
    cancel: string
  }
}

export function FooterActions({
  cancelModalOpen,
  onCancelModalOpen,
  canGoBack = false,
  onHandleGoBack,
  primaryButtonDisabled,
  primaryButtonText = 'Continuar',
  loading,
  onCancelConfirm,
  onCancelDismiss,
  onCancelRequest,
}: FooterActionsProps) {
  const matchesMd = useMediaQuery('(min-width: 768px)', {
    initializeWithValue: false,
  })
  const matchesSm = useMediaQuery('(max-width: 767px)', {
    initializeWithValue: false,
  })

  const shouldRenderCancelButton = matchesMd || !canGoBack
  const shouldRenderGoBackButton = () => {
    if (canGoBack) {
      if (matchesSm) {
        return (
          <LinkButton type="button" onClick={onHandleGoBack} variant="default">
            Voltar
          </LinkButton>
        )
      }
      return (
        <SecondaryButton
          type="button"
          variant="default"
          size="md"
          onClick={onHandleGoBack}
        >
          <IconArrowLeft />
          Voltar
        </SecondaryButton>
      )
    }

    return null
  }

  return (
    <div className="bottomActions">
      <ModalRoot modal open={cancelModalOpen} onOpenChange={onCancelModalOpen}>
        {shouldRenderCancelButton && (
          <ModalTrigger asChild>
            <LinkButton
              type="button"
              variant="neutral"
              onClick={onCancelRequest}
            >
              Cancelar
            </LinkButton>
          </ModalTrigger>
        )}

        <CancelModal onConfirm={onCancelConfirm} onDismiss={onCancelDismiss} />
      </ModalRoot>
      <div>
        {shouldRenderGoBackButton()}
        <PrimaryButton
          type="submit"
          size="md"
          disabled={primaryButtonDisabled}
          loading={loading}
          style={{ width: `${matchesSm ? '100%' : 'fit-content'}` }}
        >
          {primaryButtonText}
          <IconArrowRight />
        </PrimaryButton>
      </div>
    </div>
  )
}
